import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {MouseEvent, useState} from "react";
import {useFormEditor} from "./FormEditorDataProvider";
import I18n from "i18n-js";
import {CopyAll} from "@mui/icons-material";
import {copyWaiverById} from "../../features/waivers/waiverApi";
import {globalMessageHandler} from "../../common";
import {useNavigate} from "react-router-dom";

export interface FormEditorMenuProps {
  waiverId?: number;
}

export default function FormEditorMenu({waiverId}: FormEditorMenuProps) {
  const {onChange, value, handleAddBlocks} = useFormEditor();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon/>
      </IconButton>
      <Menu
        id="field-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {
          waiverId
            ? (
              <MenuItem
                onClick={async evt => {
                  evt.stopPropagation();
                  const response = await copyWaiverById(waiverId);
                  // Close menu for better visualization of cloned success
                  setAnchorEl(null);

                  if (response.success && response.data.data.newWaiverId) {
                    globalMessageHandler.success(I18n.t("Waiver.successCloned"));
                    navigate(`/waivers/${response.data.data.newWaiverId}`);
                  } else {
                    globalMessageHandler.error(I18n.t("Waiver.errorCloned"));
                  }
                }}
              >
                <ListItemIcon>
                  <ContentCopyIcon/>
                </ListItemIcon>
                <ListItemText
                  primary={I18n.t("FormEditor.clone")}
                  secondary={I18n.t("FormEditor.cloneDescription")}
                />
              </MenuItem>
            )
            : ''
        }
        <MenuItem
          onClick={async evt => {
            evt.stopPropagation();
            const text = await navigator.clipboard.readText();
            if (text) {
              onChange && onChange({target: {value: JSON.parse(text)}});
            }
          }}
        >
          <ListItemIcon>
            <ContentPasteIcon/>
          </ListItemIcon>
          <ListItemText
            primary="Paste"
            secondary="Paste waiver data from clipboard"
          />
        </MenuItem>
        <MenuItem
          onClick={async evt => {
            evt.stopPropagation();
            await navigator.clipboard.writeText(JSON.stringify(value));
          }}
        >
          <ListItemIcon>
            <CopyAll/>
          </ListItemIcon>
          <ListItemText
            primary="Copy"
            secondary="Copy waiver data to clipboard"
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            onChange && onChange({target: {value: null}});
          }}
        >
          <ListItemIcon>
            <CloseIcon/>
          </ListItemIcon>
          <ListItemText
            primary="Reset"
            secondary="Remove all fields from waiver"
          />
        </MenuItem>
      </Menu>
    </>
  );
}
